import { BarChart3, TrendingUp, Shield } from "lucide-react";

export default function WhatIsSection() {
  const pillars = [
    {
      number: "1",
      title: "Leitura estrutural diária",
      icon: BarChart3,
    },
    {
      number: "2",
      title: "Previsibilidade operacional",
      icon: TrendingUp,
    },
    {
      number: "3",
      title: "Sustentabilidade estratégica da meta",
      icon: Shield,
    },
  ];

  return (
    <section
      id="what-is"
      className="relative py-16 md:py-32 bg-[#1C1F26]"
      data-testid="what-is-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
            O que é
          </span>

          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB] mb-6">
            O que é o <span className="text-[#F59E0B]">KpAction</span>
          </h2>

          <p className="text-base md:text-lg text-[#9CA3AF] max-w-3xl mx-auto">
            KpAction é uma{" "}
            <span className="text-[#E5E7EB] font-medium">
              estrutura de inteligência dinâmica operacional
            </span>{" "}
            que roda localmente na sua empresa.
          </p>
        </div>

        {/* Pillars */}
        <div className="text-center mb-12">
          <p className="text-[#9CA3AF] mb-8">
            Ele organiza sua operação sob três pilares:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="relative bg-[#0F1115] border border-[#2A2F38] rounded-sm p-8 hover:border-[#F59E0B]/50 transition-all group"
              data-testid={`pillar-${index}`}
            >
              {/* Number Badge */}
              <div className="absolute -top-4 left-6 w-8 h-8 flex items-center justify-center bg-[#F59E0B] text-black font-bold text-sm rounded-sm">
                {pillar.number}
              </div>

              <div className="pt-4">
                <pillar.icon className="h-8 w-8 text-[#F59E0B] mb-4" />
                <h3 className="font-heading text-xl font-bold text-[#E5E7EB] tracking-tight">
                  {pillar.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Statement */}
        <div className="text-center max-w-2xl mx-auto">
          <div className="bg-[#0F1115] border border-[#2A2F38] rounded-sm p-8">
            <p className="text-[#9CA3AF] text-base md:text-lg mb-2">
              Não é um dashboard decorativo.
            </p>
            <p className="text-[#F59E0B] text-lg md:text-xl font-medium mb-4">
              É uma leitura operacional determinística.
            </p>
            <div className="pt-4 border-t border-[#2A2F38]">
              <p className="text-sm text-[#6B7280] italic mb-2">
                Você não precisa entender os cálculos.
              </p>
              <p className="text-sm text-[#9CA3AF] mb-4">
                O KpAction organiza os sinais operacionais da sua estrutura para facilitar interpretação e tomada de decisão baseada em dados.
              </p>
              <p className="text-sm text-[#9CA3AF]">
                O KpAction não mede apenas o que está acontecendo. Ele revela como a sua operação está se comportando — e para onde ela tende a ir.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
